// Closes a popover on a press outside its wrapper, while it is open.

import { useEffect } from 'react'

export function useOutsideClose(ref, open, close) {
  useEffect(() => {
    if (!open) return undefined
    function onPress(event) {
      if (ref.current && !ref.current.contains(event.target)) close()
    }
    document.addEventListener('pointerdown', onPress)
    return () => document.removeEventListener('pointerdown', onPress)
  }, [ref, open, close])
}
